import { serviceRequest } from 'utils/http';
import { SiteService } from 'common/api';

export function getInvestigatorSitesApi(id: string) {
  return serviceRequest(() => SiteService.siteControllerByInvestigator(id));
}
